// src/components/admin/page-management/ImageUploader.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ImageUploader = ({ onImageUpload, pageSlug }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState(null);
  const [debugInfo, setDebugInfo] = useState('');

  // Log the pageSlug prop whenever it changes
  useEffect(() => {
    console.log('ImageUploader received pageSlug:', pageSlug);
    setDebugInfo(`Current page slug: ${pageSlug || 'none'}`);
  }, [pageSlug]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Create form data
    const formData = new FormData();
    formData.append('image', file);
    
    // Clean the slug
    const cleanSlug = pageSlug ? pageSlug.replace(/[^a-zA-Z0-9-_]/g, '') : 'shared';
    
    // Add to form data too, as a backup
    formData.append('pageSlug', cleanSlug);
    
    // Debug logs
    console.log(`Uploading image for page: ${cleanSlug}`);
    setDebugInfo(`Uploading for: ${cleanSlug}`);

    setUploading(true);
    setUploadProgress(0);
    setError(null);

    try {
      // Get token from localStorage directly
      const token = localStorage.getItem('token');
      
      // Use query parameter for the page slug - this is the key change!
      const response = await axios.post(`/api/upload-page-image?pageSlug=${cleanSlug}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });

      setUploading(false);
      
      // Call the callback with the uploaded image URL
      if (onImageUpload && response.data && response.data.filePath) {
        console.log('Image uploaded successfully:', response.data.filePath);
        setDebugInfo(`Upload success: ${response.data.filePath}`);
        onImageUpload(response.data.filePath);
      }
    } catch (err) {
      setUploading(false);
      setError(err.response?.data?.error || 'Error uploading image');
      setDebugInfo(`Upload error: ${err.message}`);
      console.error('Upload error:', err);
    }
  };

  return (
    <div className="mb-4">
      <div className="flex items-center space-x-2">
        <label className="cursor-pointer px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm">
          <span>Choose File</span>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
            disabled={uploading}
          />
        </label>
        {uploading && (
          <div className="flex-1 relative h-8 bg-gray-200 rounded overflow-hidden">
            <div 
              className="absolute top-0 left-0 h-full bg-blue-500 transition-all"
              style={{ width: `${uploadProgress}%` }}
            ></div>
            <div className="absolute inset-0 flex items-center justify-center text-xs">
              {uploadProgress}%
            </div>
          </div>
        )}
      </div>
      
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
      
      {/* Debug info displayed on the UI */}
      <p className="text-xs bg-gray-100 p-1 mt-1">{debugInfo}</p>
      
      <p className="text-xs text-gray-500 mt-1">
        Upload an image or provide a URL above
      </p>
    </div>
  );
};

export default ImageUploader;







// // src/components/admin/page-management/ImageUploader.js
// import React, { useState } from 'react';
// import axios from 'axios';
// import { useAuth } from '../../../context/AuthContext'; // Import the auth context

// const ImageUploader = ({ onImageUpload, pageSlug }) => {
//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [error, setError] = useState(null);
//   const { user } = useAuth(); // Get the user from context, though we don't actually need it directly

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('image', file);
    
//     // Add page slug to identify where the image belongs
//     if (pageSlug) {
//       formData.append('pageSlug', pageSlug);
//     }

//     setUploading(true);
//     setUploadProgress(0);
//     setError(null);

//     try {
//       // Get token from localStorage directly (this matches your AuthContext implementation)
//       const token = localStorage.getItem('token');
      
//       const response = await axios.post('/api/upload-page-image', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'Authorization': `Bearer ${token}` // Use token from localStorage
//         },
//         onUploadProgress: (progressEvent) => {
//           const percentCompleted = Math.round(
//             (progressEvent.loaded * 100) / progressEvent.total
//           );
//           setUploadProgress(percentCompleted);
//         },
//       });

//       setUploading(false);
      
//       // Call the callback with the uploaded image URL
//       if (onImageUpload && response.data && response.data.filePath) {
//         onImageUpload(response.data.filePath);
//       }
//     } catch (err) {
//       setUploading(false);
//       setError(err.response?.data?.error || 'Error uploading image');
//       console.error('Upload error:', err);
//     }
//   };

//   return (
//     <div className="mb-4">
//       <div className="flex items-center space-x-2">
//         <label className="cursor-pointer px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm">
//           <span>Choose File</span>
//           <input
//             type="file"
//             accept="image/*"
//             className="hidden"
//             onChange={handleFileChange}
//             disabled={uploading}
//           />
//         </label>
//         {uploading && (
//           <div className="flex-1 relative h-8 bg-gray-200 rounded overflow-hidden">
//             <div 
//               className="absolute top-0 left-0 h-full bg-blue-500 transition-all"
//               style={{ width: `${uploadProgress}%` }}
//             ></div>
//             <div className="absolute inset-0 flex items-center justify-center text-xs">
//               {uploadProgress}%
//             </div>
//           </div>
//         )}
//       </div>
      
//       {error && (
//         <p className="text-red-500 text-sm mt-1">{error}</p>
//       )}
      
//       <p className="text-xs text-gray-500 mt-1">
//         Upload an image or provide a URL above
//       </p>
//     </div>
//   );
// };

// export default ImageUploader;